import { render, staticRenderFns } from "./TestTaskEdit.vue?vue&type=template&id=13ae6be0"
import script from "./TestTaskEdit.vue?vue&type=script&lang=js"
export * from "./TestTaskEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports